
import React from 'react'

const CustomerDetails = ({customer_name,address,gst_no,drug_licence1,drug_licence2,drug_licence3}) => {
  return (
   <>
   <h4>Customer Name:{customer_name}</h4>
    <h4>Address: {address}</h4>
    <h4>GST No: {gst_no} </h4>
    <h4>DL Nos: {drug_licence1}, {drug_licence2}, {drug_licence3}</h4>
     </>
  )
}

export default CustomerDetails